import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

const ModalCargo = ({
	show,
	onHide,
	cargoEditando,
	dataCursos,
	customStyles,
	register,
	control,
	errors,
	handleSubmit,
	onSubmit,
	loading
}) => {
	useEffect(() => {
		if (!show) return;
	}, [show]);

	return (
		<Modal show={show} size="lg" onHide={onHide} backdrop="static">
			<form
				onSubmit={(e) => {
					e.stopPropagation();
					handleSubmit(onSubmit)(e);
				}}
			>
				<Modal.Header closeButton>
					<span className="fw-semibold fs-5 text-primary">
						{cargoEditando ? 'Editar Cargo' : 'Novo Cargo'}
					</span>
				</Modal.Header>
				<Modal.Body className="bg-gray-100 p-4">
					<div className="mb-3">
						<label className="form-label text-primary fw-medium">Nome do cargo</label>
						<input
							type="text"
							{...register('nome', { required: 'Nome é obrigatório' })}
							placeholder="Ex: Operador"
							className="form-control border-new-light"
						/>
						{errors.nome && <span className="text-danger fs-7">{errors.nome.message}</span>}
					</div>

					<div className="mb-3">
						<label className="form-label text-primary fw-medium">Cursos vinculados (opcional)</label>
						<Controller
							name="cursos"
							control={control}
							defaultValue={[]}
							render={({ field }) => (
								<Select
									{...field}
									isMulti
									options={dataCursos.map((curso) => ({
										value: curso.id,
										label: curso.nome
									}))}
									value={field.value}
									styles={customStyles}
									onChange={(value) => field.onChange(value || [])}
									placeholder="Selecione os cursos"
									noOptionsMessage={() => 'Nenhum curso encontrado.'}
								/>
							)}
						/>
						<small className="text-muted">Cursos serão sugeridos automaticamente ao cadastrar alunos com este cargo.</small>
					</div>
				</Modal.Body>
				<Modal.Footer className="justify-content-end">
					<button type="button" className="btn me-2" onClick={onHide} disabled={loading}>
						Cancelar
					</button>
					<button type="submit" className="btn btn-primary" disabled={loading}>
						{loading ? (
							<>
								<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
								Salvando...
							</>
						) : (
							'Salvar'
						)}
					</button>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default ModalCargo;
